export const brandVoice = {
  title: 'Voces de Marca',
  subtitle: 'Define los lineamientos de comunicación para mantener consistencia en tu contenido',

  actions: {
    new: 'Nueva Voz',
    edit: 'Editar',
    delete: 'Eliminar',
    duplicate: 'Duplicar',
    viewDetails: 'Ver Detalles',
    save: 'Guardar',
    cancel: 'Cancelar',
    back: 'Volver a Voces',
  },

  table: {
    name: 'Nombre',
    voiceTone: 'Voz de Marca',
    elements: 'Elementos',
    actions: 'Acciones',
    openMenu: 'Abrir menú',
    empty: {
      title: 'No hay voces de marca configuradas',
      subtitle: 'Crea tu primera voz de marca para comenzar',
      cta: 'Crear voz de marca',
    },
  },

  form: {
    createTitle: 'Nueva Voz de Marca',
    editTitle: 'Editar Voz de Marca',

    basicInfo: {
      title: 'Información Básica',
      subtitle: 'Datos principales de tu voz de marca',
    },

    name: {
      label: 'Nombre de la Voz',
      placeholder: 'Ej: Mi Marca Principal',
      required: 'El nombre es requerido',
      hint: 'Un nombre descriptivo para identificar esta voz de marca',
    },

    voiceTone: {
      label: 'Tono de Voz',
      placeholder:
        'Ej: Profesional, cercano y confiable. Transmite seguridad y expertise sin ser arrogante.',
      required: 'El tono de voz es requerido',
      tooltip: 'Describe cómo debe sonar tu marca. Ej: Profesional pero cercano, técnico pero accesible.',
    },

    targetAudience: {
      label: 'Audiencia Objetivo',
      placeholder: 'Ej: CTOs y líderes técnicos de empresas B2B en Latinoamérica',
      tooltip: 'A quién te diriges principalmente con esta voz de marca.',
    },

    identity: {
      title: 'Identidad de Marca',
      subtitle: 'Valores y estilo que definen tu comunicación',
    },

    brandValues: {
      label: 'Valores de Marca',
      placeholder: 'Ej: Innovación, transparencia, excelencia, compromiso',
      hint: 'Separa los valores con comas',
    },

    communicationStyle: {
      label: 'Estilo de Comunicación',
      placeholder: 'Ej: Directo, informativo, con datos de respaldo y ejemplos prácticos',
    },

    guidelines: {
      title: 'Lineamientos de Comunicación',
      subtitle: 'Define qué hacer y qué evitar en la comunicación',

      do: {
        label: 'Qué Hacer',
        placeholder: 'Ej: Usar lenguaje inclusivo y presionar Enter',
        tooltip: 'Lineamientos positivos: qué tipo de lenguaje y enfoque usar.',
      },

      dont: {
        label: 'Qué NO Hacer',
        placeholder: 'Ej: Usar jerga técnica excesiva y presionar Enter',
        tooltip: 'Restricciones: qué evitar en la comunicación.',
      },
    },

    examples: {
      title: 'Ejemplos de Comunicación',
      subtitle: 'Incluye fragmentos de texto que ejemplifiquen cómo debe sonar la marca',
      placeholder:
        'Pega aquí ejemplos reales de comunicación que representen bien tu voz de marca. Pueden ser fragmentos de emails, publicaciones, descripciones de producto, etc.',
    },

    preview: {
      title: 'Vista Previa',
      subtitle: 'Así se verá tu voz de marca',
      audience: 'Audiencia',
      values: 'Valores',
      guidelines: 'Lineamientos',
      elementsCompleted: 'Elementos completados',
      defaultName: 'Nombre de la voz',
      defaultDescription: 'Descripción del tono de voz...',
    },

    progress: {
      complete: '% completo',
    },

    saving: 'Guardando...',
    creating: 'Creando...',
    updating: 'Actualizando...',
  },

  delete: {
    title: 'Eliminar Voz de Marca',
    description: 'Esta acción no se puede deshacer. La voz de marca será eliminada permanentemente.',
    confirm: 'Eliminar',
    cancel: 'Cancelar',
    deleting: 'Eliminando...',
  },

  toast: {
    createSuccess: 'Voz de marca creada exitosamente',
    createError: 'Error al crear voz de marca: {{message}}',
    updateSuccess: 'Voz de marca actualizada exitosamente',
    updateError: 'Error al actualizar voz de marca: {{message}}',
    deleteSuccess: 'Voz de marca eliminada exitosamente',
    deleteError: 'Error al eliminar voz de marca: {{message}}',
    duplicateSuccess: 'Voz de marca duplicada exitosamente',
    duplicateError: 'Error al duplicar voz de marca: {{message}}',
  },

  templates: {
    pageTitle: 'Elegir una Plantilla',
    pageSubtitle: 'Comienza con un arquetipo de voz probado y personalízalo para tu marca',
    startFromScratch: 'Empezar desde Cero',
    startFromScratchDescription: 'Construye tu voz de marca desde cero con un lienzo en blanco',
    previewDos: 'Hacer',
    previewDonts: 'No hacer',

    professional: {
      name: 'Profesional / Corporativo',
      description: 'Tono autoritativo y pulido para comunicaciones B2B y empresariales',
    },
    friendly: {
      name: 'Amigable / Conversacional',
      description: 'Cálido y cercano, como hablar con un amigo que sabe del tema',
    },
    bold: {
      name: 'Audaz / Disruptivo',
      description: 'Tono seguro y provocador que desafía el status quo',
    },
    educational: {
      name: 'Educativo / Experto',
      description: 'Explicaciones claras y metódicas que empoderan el aprendizaje',
    },
    luxury: {
      name: 'Lujo / Premium',
      description: 'Lenguaje elegante y refinado que evoca exclusividad',
    },
    playful: {
      name: 'Lúdico / Creativo',
      description: 'Voz divertida e imaginativa llena de personalidad y sorpresa',
    },
    empathetic: {
      name: 'Empático / Cercano',
      description: 'Tono compasivo y solidario que hace sentir escuchado',
    },
    technical: {
      name: 'Técnico / Desarrollador',
      description: 'Contenido preciso y práctico para ingenieros y desarrolladores',
    },
    inspirational: {
      name: 'Inspirador / Motivacional',
      description: 'Lenguaje estimulante y energizante que despierta posibilidades',
    },
    minimalist: {
      name: 'Minimalista / Directo',
      description: 'Cada palabra cuenta — comunicación clara, concisa y con propósito',
    },
  },

  footer: {
    total: 'total',
  },
} as const
